function Form({ children, onSubmit }) {
    return (
        <form class="mt-4" onSubmit={onSubmit}>
            {children}
        </form>
    )
}

export default Form;